import { Directive, ElementRef, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { FuseLoadingBarService } from '@fuse/components/loading-bar/loading-bar.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Directive({
  // Target all standard buttons and Material design buttons/links
  selector:
    'button:not([no-global-disable]), a[mat-button], a[mat-raised-button], a[mat-icon-button], a[mat-fab], a[mat-mini-fab], a[mat-stroked-button], a[mat-flat-button]'
})
export class GlobalLoadingDisableDirective implements OnInit, OnDestroy {
  private _unsubscribeAll: Subject<any> = new Subject<any>();

  constructor(
    private _fuseLoadingBarService: FuseLoadingBarService,
    private _elementRef: ElementRef,
    private _renderer: Renderer2
  ) {}

  ngOnInit(): void {
    this._fuseLoadingBarService.show$.pipe(takeUntil(this._unsubscribeAll)).subscribe(isLoading => {
      if (isLoading) {
        // We use a class or pointer-events to prevent interaction
        // without conflicting with existing [disabled] bindings
        this._renderer.addClass(this._elementRef.nativeElement, 'pointer-events-none');
        this._renderer.addClass(this._elementRef.nativeElement, 'opacity-50');
        this._renderer.setAttribute(this._elementRef.nativeElement, 'tabindex', '-1');
      } else {
        this._renderer.removeClass(this._elementRef.nativeElement, 'pointer-events-none');
        this._renderer.removeClass(this._elementRef.nativeElement, 'opacity-50');
        this._renderer.removeAttribute(this._elementRef.nativeElement, 'tabindex');
      }
    });
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }
}
